import { render, staticRenderFns } from "./fpcList.vue?vue&type=template&id=30706b30&scoped=true&"
import script from "./fpcList.vue?vue&type=script&lang=js&"
export * from "./fpcList.vue?vue&type=script&lang=js&"
import style0 from "./fpcList.vue?vue&type=style&index=0&id=30706b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30706b30",
  null
  
)

export default component.exports